import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GeneralEnterpriseSubscriptionSupportTier, GeneralSubscription } from '@mews-commander/data-access';
import { replace } from '@mews/routing';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { removeUrlParam, getUrlParameter } from '@mews-commander/utils';
import { getCurrentEnterpriseSubscription } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { HELP_CENTER_SIDEBAR_NAME } from '../../helpCenter';
import { openDialog } from '../../dialog/reducer';
import { OPEN_SUPPORT_TICKET_URL_PARAM } from '../../helpCenter/constants';

export const useOpenTicketByUrlParam = () => {
    const isAdaEmbeddedFeatureFlagEnabled = useFeatureFlag(FeatureFlag.adaEmbeddedFeatureFlagEnabled);
    const { supportTier }: GeneralSubscription = useSelector(getCurrentEnterpriseSubscription);
    const dispatch = useDispatch();

    useEffect(() => {
        const isOpenSupportTicketUrlParam = getUrlParameter(OPEN_SUPPORT_TICKET_URL_PARAM) !== undefined;
        if (
            isOpenSupportTicketUrlParam &&
            supportTier === GeneralEnterpriseSubscriptionSupportTier.Standard &&
            !isAdaEmbeddedFeatureFlagEnabled
        ) {
            dispatch(openDialog(HELP_CENTER_SIDEBAR_NAME));
            dispatch(replace(removeUrlParam(OPEN_SUPPORT_TICKET_URL_PARAM)));
        }
    }, [dispatch, isAdaEmbeddedFeatureFlagEnabled, supportTier]);
};
